<template>
  <v-card outlined class="mb-2">
    <v-card-title>{{ title }}</v-card-title>
    <v-card-subtitle>{{ name }}</v-card-subtitle>
    <v-divider />
    <v-card-text class="pb-0">
      <v-expansion-panels flat>
        <v-expansion-panel key="settings">
          <v-expansion-panel-header
            ><v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <span v-bind="attrs" v-on="on">Settings</span>
              </template>
              <span v-html="settingsLabel"></span>
            </v-tooltip>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <v-col
                v-for="setting of settings"
                :key="setting.settingName"
                :sm="setting.size ? setting.size : 3"
              >
                <template v-if="setting.settingType == 'BOOLEAN'">
                  <v-switch
                    :label="setting.settingLabel"
                    dense
                    @change="onSettingChange($event, setting)"
                    v-model="setting.settingValue"
                  />
                </template>
                <template v-if="setting.settingType == 'TEXT'">
                  <v-text-field
                    :label="setting.settingLabel"
                    v-model="setting.settingValue"
                    dense
                    :outlined="outlinedInputs"
                    @change="onSettingChange($event, setting)"
                  />
                </template>
                <template v-if="setting.settingType == 'COLOR'">
                  <h4>{{ setting.settingLabel }}</h4>
                  <v-color-picker
                    mode="hexa"
                    dot-size="25"
                    swatches-max-height="100"
                    :label="setting.settingLabel"
                    v-model="setting.settingValue"
                    dense
                    :outlined="outlinedInputs"
                    @input="onSettingChange($event, setting)"
                  ></v-color-picker>
                </template>
                <template v-if="setting.settingType == 'NUMBER'">
                  <v-text-field
                    :label="setting.settingLabel"
                    v-model:number="setting.settingValue"
                    dense
                    :outlined="outlinedInputs"
                    @change="onSettingChange($event, setting)"
                    type="number"
                  />
                </template>
                <template v-if="setting.settingType == 'CONTENT'">
                  <vue-editor
                    :label="setting.settingLabel"
                    v-model="setting.settingValue"
                    dense
                    :outlined="outlinedInputs"
                    @input="onSettingChange($event, setting)"
                  ></vue-editor>
                </template>

                <template v-if="setting.settingType == 'ENUM'">
                  <v-select
                    :label="setting.settingLabel"
                    v-model="setting.settingValue"
                    :items="JSON.parse(setting.settingValues)"
                    dense
                    :outlined="outlinedInputs"
                    @input="onSettingChange($event, setting)"
                  ></v-select>
                </template>
                <template v-if="setting.settingType == 'MULTI_ENUM'">
                  <v-select
                    :label="setting.settingLabel"
                    v-model="setting.settingValue"
                    :items="JSON.parse(setting.settingValues)"
                    dense
                    :outlined="outlinedInputs"
                    @input="onSettingChange($event, setting)"
                    multiple
                  ></v-select>
                </template>
              </v-col>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>

      <div v-if="debug">
        <code>{{ section }}</code>
      </div>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="warning" text @click="onRemove">Remove</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { removeGQLTypename } from "../../../../helpers";
import { VueEditor } from "vue2-editor";
export default {
  name: "document-section",

  props: {
    section: {
      type: Object,
      default: () => null,
    },
  },

  components: { VueEditor },

  data() {
    return {
      debug: false,
      name: this.section ? this.section.name : "Component Name",
      description: this.section
        ? this.section.description
        : "Component Description",
      settings: this.section
        ? [
            ...this.section.settings.map(removeGQLTypename).map((s) => ({
              ...s,
              settingValue:
                s.settingType == "MULTI_ENUM"
                  ? s.settingValue.split(",")
                  : s.settingType == "BOOLEAN"
                  ? s.settingValue.toString() == "true"
                  : s.settingValue,
            })),
          ]
        : [],
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    settingsLabel() {
      if (this.section) {
        return this.section.settings
          .map((s) => `<strong>${s.settingLabel}:</strong> ${s.settingValue}`)
          .join(", <br>");
      } else {
        return "";
      }
    },
    title() {
      if (this.section) {
        const titleSetting = this.section.settings.find(
          (s) =>
            s.settingValue != "" &&
            (s.settingName == "title" || s.settingName == "menu_label")
        );
        //console.log(titleSetting);
        return titleSetting ? titleSetting.settingValue : "";
      } else {
        return "";
      }
    },
  },

  methods: {
    onRemove() {
      this.$emit("remove", { ...this.section });
    },
    onSettingChange(val, payload) {
      this.$emit("change", {
        ...this.section,
        settings: [
          ...this.settings.map((s) => ({
            ...s,
            settingValue: s.settingValue.toString(),
          })),
        ],
      });
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/admin/documents/DocumentSection.vue